<template>
    <div>
        <Card>
            <p slot="title"> Tambah Pembayaran </p>

            <Form :label-width="120">
                <Card style="width:50%" v-if="paymentGiroId">
                    <p slot="title" >Giro Info</p>
                    <Button
                        slot="extra"
                        size="small"
                        @click="goToPaymentGiroList()">Cancel</Button>

                    <template v-if="finishLoading">
                        <Row type="flex" justify="center" align="middle" class="code-row-bg">
                            <Col span="10">
                                {{ paymentGiro.transactionDate | dateFormatted }}
                                <h5>{{ paymentGiro.bankAccountName }}</h5>
                            </Col>
                            <Col span="12" offset="2" style="text-align:right">
                                <Tag type="border" color="blue"> {{ paymentGiro.amount | numberFormatted }} </Tag>
                            </Col>
                        </Row>
                    </template>
                </Card>
                <br/> <hr/> <br/>

                <Form-item label="Tgl Pembayaran">
                    <Row>
                        <Col span="4">
                            <Date-picker v-model="paymentDate"
                                style="width: 110px;"
                                type="date"
                                placeholder=""
                                format="dd/MM/yyyy">
                            </Date-picker>
                        </Col>
                        <Col span="2">
                            <Select
                                v-model="searchSelectSubbranch"
                                disabled
                                placeholder="Branchcode"
                                @on-change="setMarkingCode"
                                >
                                <Option v-for="subbranch, idx in subbranchs" :value="subbranch.subbranchcode" :key="idx">
                                    {{ subbranch.subbranchname }}
                                </Option>
                            </Select>
                        </Col>
                        <Col span="1">&nbsp;
                        </Col>
                        <Col span="3" v-show="paymentDate !=''">
                            <i-switch size="large" v-model="isGroup" disabled>
                                <span slot="open">Group</span>
                                <span slot="close">Mark</span>
                            </i-switch>
                        </Col>
                        <!-- <Col span="5" v-show="paymentDate !='' && isGroup == false && paymentGiroId && paymentGiroMarking == ''">
                            <Select
                                style="width: 250px;"
                                placeholder="Ketik Marking"
                                v-model="markingIdSelected"
                                filterable
                                clearable
                                remote
                                :remote-method="getMarkingByCode"
                                :loading="loadingGetMarking"
                                @on-change="getInvoiceData" >
                                <Option v-for="option in optionMarkings"
                                    :value="option.value"
                                    :key="option.value">{{option.label}}</Option>
                            </Select>
                        </Col> -->
                        <Col span="5" v-show="paymentDate !='' && isGroup == false && paymentGiroId && paymentGiroMarking">
                            <Input v-model="paymentGiroMarking" style="width: 200px;" disabled></Input>
                        </Col>
                        <!-- <Col span="5" v-show="paymentDate !='' && isGroup == false && paymentGiroId && paymentGiroMarking">
                            <Button
                                type="primary"
                                :loading="loadingPost"
                                @click="getInvoiceData"
                                icon="ios-search"
                                size="small">
                                    Search
                            </Button>
                        </Col> -->
                        <!-- <Col span="5" v-show="paymentDate !='' && isGroup == true && paymentGiroId && paymentGiroMarkingGroup == ''">
                            <Select
                                style="width: 250px;"
                                placeholder="Ketik Group Name"
                                v-model="markingIdSelected"
                                filterable
                                clearable
                                remote
                                :remote-method="getGroupMarkingByCode"
                                :loading="loadingGetMarking"
                                @on-change="getInvoiceDataByGroupMarking" >
                                <Option v-for="option in optionGroupMarkings"
                                    :value="option.value"
                                    :key="option.value">{{option.label}}</Option>
                            </Select>
                        </Col> -->
                        <Col span="5" v-show="paymentDate !='' && isGroup && paymentGiroId && paymentGiroMarkingGroup">
                            <Input v-model="paymentGiroMarkingGroup" style="width: 200px;" disabled></Input>
                        </Col>
                        <!-- <Col span="5" v-show="paymentDate !='' && isGroup && paymentGiroId && paymentGiroMarkingGroup">
                            <Button
                                type="primary"
                                :loading="loadingPost"
                                @click="getInvoiceDataByGroupMarking"
                                icon="ios-search"
                                size="small">
                                    Search
                            </Button>
                        </Col> -->
                        <Col span="1" offset="1">
                        <Spin size="large" v-show="loadingGetPayment"></Spin>
                        </Col>
                    </Row>
                </Form-item>

                <Form-item label="Keterangan"
                    v-show="paymentDate !='' && markingIdSelected != '' && invoiceDues.length > 0 ">
                    <!-- <Textarea v-model="description" style="width: 500px;"></Textarea> -->

                    <Input v-model="description" type="textarea" :rows="4" style="width: 700px; height:100px;" ></Input>
                </Form-item>
                <Form-item label="Total Deposit"
                    v-show="paymentDate != '' && markingIdSelected != '' && depositRemaining != 0">
                    <Alert style="width: 30%;" type="warning" show-icon> {{ depositRemaining | currency }}
                    </Alert>
                    <font style="color: red;"
                        v-if="totalUseDepositAmount > 0 && totalUseDepositAmount > depositRemaining">Terpakai
                        {{ totalUseDepositAmount | currency }} - LEBIH
                    </font>

                    <font style="color: green;"
                        v-if="totalUseDepositAmount > 0 && totalUseDepositAmount <= depositRemaining">
                        Terpakai: {{ totalUseDepositAmount | currency }}, Sisa: {{ (depositRemaining -
                            totalUseDepositAmount) |
                            currency }}
                    </font>
                </Form-item>
                <Form-item label="Klaim" prop="claim">
                    <Select placeholder="Masukan Klaim yang sesuai dengan Mutasi" v-model="claims" filterable multiple :disabled="optionClaims.length === 0"
                        style="width: 30%;">
                        <Option v-for="(option, index) in optionClaims" :value="option.value" :key="index">
                            {{ option.label }}</Option>
                    </Select>
                    <Button type="info" icon="ios-refresh" @click="getClaims" :loading="loadingGetClaims">Refresh Klaim</Button>
                </Form-item>
                <Form-item label="Total Mutasi Deposit"
                    v-show="paymentDate != '' && markingIdSelected != '' && invoiceDues.length > 0 && depositMutasiRemaining">
                    <Alert style="width: 30%;" type="warning" show-icon>
                        {{ depositMutasiRemaining | currency }}
                    </Alert>

                    <font style="color: red;"
                        v-if="totalUseDepositMutasi > 0 && totalUseDepositMutasi > depositMutasiRemaining">
                        Terpakai
                        {{ totalUseDepositMutasi | currency }} - LEBIH
                    </font>

                    <font style="color: green;"
                        v-if="totalUseDepositMutasi > 0 && totalUseDepositMutasi <= depositMutasiRemaining">
                        Terpakai: {{ totalUseDepositMutasi | currency }}, Sisa: {{ (depositMutasiRemaining -
                            totalUseDepositMutasi) |
                            currency }}
                    </font>
                </Form-item>

                <Form-item label="Deposit"
                    v-show="paymentDate !='' && markingIdSelected != '' && depositRemaining != 0 ">

                    <Alert
                        style="width: 300px;"
                        type="warning" show-icon>{{ depositRemaining | currency }}
                    </Alert>
                    <font
                        style="color: red;"
                        v-if="totalUseDepositAmount > 0 && totalUseDepositAmount > depositRemaining">Terpakai {{totalUseDepositAmount | currency}} - LEBIH</font>

                    <font
                        style="color: green;"
                        v-if="totalUseDepositAmount > 0 && totalUseDepositAmount <= depositRemaining">
                            Terpakai: {{totalUseDepositAmount | currency}}, Sisa: {{ (depositRemaining - totalUseDepositAmount) | currency}}
                        </font>
                </Form-item>

                <Form-item label="Uang Diterima"
                    v-show="paymentDate !='' && markingIdSelected != '' && invoiceDues.length > 0 ">
                    <money
                        v-model="amountReceived"
                        v-bind="money"
                        class="ivu-input right"
                        style="width: 150px;"></money>

                        <font v-show="amountResidue != 0"
                            style="margin-left: 20px;">
                            Selisih &nbsp; {{amountResidue | currency}}
                        </font>
                </Form-item>

                <Form-item label="Uang Potongan"
                    v-show="paymentDate !='' && markingIdSelected != '' && invoiceDues.length > 0 && paymentGiroId ">
                    <money
                        v-model="discountReceived"
                        v-bind="money"
                        class="ivu-input right"
                        style="width: 150px;"></money>
                </Form-item>

                <Form-item label="Kategori"
                    v-show="paymentDate !='' && markingIdSelected != '' && invoiceDues.length > 0 && paymentGiroId == null">
                    <input type="radio" v-model="category" id="payment" value="pay"> <label for="payment">Pembayaran</label> &nbsp;&nbsp;&nbsp;
                    <input type="radio" v-model="category" id="discount" value="disc"> <label for="discount">Potongan</label>
                </Form-item>
                <Form-item label="Kategori"
                    v-show="paymentDate !='' && markingIdSelected != '' && invoiceDues.length > 0 && paymentGiroId">
                    <input type="radio" v-model="category" id="payment" value="pay"> <label for="payment">Pembayaran</label> &nbsp;&nbsp;&nbsp;
                </Form-item>

                <Alert v-show="depositAmount != 0"
                    type="warning" show-icon
                    style="width: 300px;">Kelebihan : {{depositAmount | currency}}</Alert>

                <Alert v-show="depositAmount != 0 && category == 'disc'"
                    type="error" show-icon style="width: 700px;"> Tidak dapat melanjutkan proses pembayaran jika terdapat Kelebihan pada Kategori Potongan.</Alert>
                <Alert v-show="depositAmount > paymentGiroAmount && paymentGiroId"
                    type="error" show-icon style="width: 700px;"> Tidak dapat melanjutkan proses pembayaran jika Alokasi Pembayaran lebih besar dari Mutasi.</Alert>

            </Form>
        </Card>

        <br/>

        <Card v-show="this.invoiceDues.length > 0 && receivableGroup == ''">
            <p slot="title"> Daftar Invoice </p>

            <Row type="flex" class="code-row-bg">
                <template>
                    <Col span="2" v-if="isGroup"> Marking </Col>
                    <Col span="3"> Tgl Bongkar </Col>
                    <Col span="7"> Keterangan </Col>
                    <Col span="3"> Total </Col>
                    <Col span="3"> Sisa </Col>
                    <Col span="5"> Alokasi Pembayaran </Col>
                    <Col span="3"> Potongan </Col>
                </template>
            </Row>

            <br/> <hr/> <br/>

            <div v-for="invoiceDue in invoiceDues" :key="invoiceDue.id">
                <cInvoicePayment
                    :invoiceDue="invoiceDue"
                    :depositRemaining="depositRemaining"
                    :depositMutasiRemaining="depositMutasiRemaining"
                    :paymentGiroId="paymentGiroId"
                    :paymentGiroAmount="paymentGiroAmount"
                    @setAllocateAmount="setAllocateAmount">
                </cInvoicePayment>
                <br/>
            </div>
        </Card>

        <Card
                v-if="receivableGroup != ''">
                <Tabs :animated="false">
                    <TabPane v-for="marking in receivableGroup" :key="marking.markingheadercode"
                            :label="marking.markingheadercode">
                            <p slot="title"> Daftar Invoice </p>

                            <Row type="flex" class="code-row-bg ivu-row-flex-space-between">
                                <template>
                                    <Col span="2"> Tgl Bongkar </Col>
                                    <Col span="6"> Keterangan </Col>
                                    <Col span="3"> Total </Col>
                                    <Col span="3"> Sisa </Col>
                                    <Col span="3"> Alokasi Pembayaran </Col>
                                    <Col span="5"> Potongan </Col>
                                </template>
                            </Row>

                            <br/> <hr/> <br/>
                             <div v-for="invoiceDue in marking.invoiceDue" :key="invoiceDue.id">
                                <cInvoicePayment
                                    :invoiceDue="invoiceDue"
                                    :depositRemaining="depositRemaining"
                                    :paymentGiroId="paymentGiroId"
                                    :paymentGiroAmount="paymentGiroAmount"
                                    @setAllocateAmount="setAllocateAmount">
                                </cInvoicePayment>
                                <br/>
                            </div>
                    </TabPane>
                </Tabs>
            </Card>




        <div class="footer" v-show="isGroup == false" >
            <Button v-show="description !='' && category != '' && (((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0) ||
              ((totalUseDepositMutasi <= depositMutasiRemaining) || depositMutasiRemaining < 0)) && paymentGiroId == null"
                type="primary"
                :loading="loadingPost"
                @click="postPayment"
                icon="checkmark-round"
                size="small">
                    <span v-if="!loadingPost && amountReceived + totalUseDepositAmount > 0">Bayar</span>
                    <span v-else-if="!loadingPost && (amountReceived == 0)">Bayar Free</span>
                    <span v-else>Wait.....</span>
            </Button>
        </div>
        <div class="footer" v-show="isGroup == false" >
            <Button v-show="description !='' && category != '' && (((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0) ||
              ((totalUseDepositMutasi <= depositMutasiRemaining) || depositMutasiRemaining < 0)) && ((depositAmount == 0 && category == 'disc') || (depositAmount >= 0 && category == 'pay')) && ((paymentGiroId && depositAmount <= paymentGiroAmount) || paymentGiroId == null)"
                type="primary"
                :loading="loadingPost"
                @click="postPaymentGiro"
                icon="checkmark-round"
                size="small"  >
                    <span v-if="!loadingPost && amountReceived + totalUseDepositAmount + totalUseDepositMutasi > 0">Bayar</span>
                    <span v-else-if="!loadingPost && (amountReceived == 0)">Bayar Free</span>
                    <span v-else>Wait.....</span>
            </Button>
        </div>
        <div class="footer" v-show="isGroup">
            <Button v-show="description !='' && category != '' && ((totalUseDepositAmount <= depositRemaining) || depositRemaining < 0)"
                type="primary"
                :loading="loadingPost"
                @click="postPaymentByGroup"
                icon="checkmark-round"
                size="small"  >
                    <span v-if="!loadingPost && amountReceived + totalUseDepositAmount + totalUseDepositMutasi > 0">Bayar</span>
                    <span v-else-if="!loadingPost && (amountReceived == 0)">Bayar Free</span>
                    <span v-else>Wait.....</span>
            </Button>
        </div>

        <Modal v-model="modalConfirmDeposit" width="500px" @on-cancel="depositType= ''">
            <p slot="header" style="color:#2d8cf0;text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Konfirmasi</span>
            </p>
            Kelebihan <b>{{ depositAmount | currency }}</b> akan dijadikan sebagai :
            <div style="text-align:left">
                <RadioGroup v-model="depositType" vertical>
                    <Radio label="DEP">
                        <span>Deposit</span>
                    </Radio>
                    <Radio label="PRF">
                        <span>Pendapatan</span>
                    </Radio>
                </RadioGroup>
            </div>
            <div slot="footer" v-show="isGroup == false && paymentGiroId == null">
                <Button
                    v-show="depositType != ''"
                    type="primary"
                    long
                    :loading="loadingPost"
                    @click="postPayment" >
                    <span v-if="!loadingPost">Bayar</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
            <div slot="footer" v-show="isGroup == false && paymentGiroId">
                <Button
                    v-show="depositType != ''"
                    type="primary"
                    long
                    :loading="loadingPost"
                    @click="postPaymentGiro" >
                    <span v-if="!loadingPost">Bayar</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
            <div slot="footer" v-show="isGroup">
                <Button
                    v-show="depositType != ''"
                    type="primary"
                    long
                    :loading="loadingPost"
                    @click="postPaymentByGroup" >
                    <span v-if="!loadingPost">Bayar</span>
                    <span v-else>Wait.....</span>
                </Button>
            </div>
        </Modal>

         <!-- Modal - konfirmasi mutasi akan dialokasikan menjadi piutang -->
        <Modal v-model="modalConfirmAutoDeposit" width="500px">
            <p slot="header" style="color:#ffffff; text-align:center">
                <Icon type="information-circled"></Icon>
                <span>Konfirmasi</span>
            </p>

            <p>
                Marking tidak memiliki piutang, apakah giro dengan Total : <b> Rp. {{ paymentGiroAmount | currency
                }} </b>
                ingin dijadikan sebagai <b>Deposit</b> ?
            </p>

            <div slot="footer">
                <Button type="error" @click="modalConfirmAutoDeposit = false">Batalkan</Button>
                <Button type="primary" :loading="loadingPost" @click="postReceivableAsDeposit">
                    <span v-if="!loadingPost">Tambahkan</span>
                    <span v-else>Mohon tunggu...</span>
                </Button>
            </div>
        </Modal>

    </div>
</template>

<script>
import {HTTP} from '../http-lib';
import {Money} from 'v-money'
import _ from 'lodash'

import moment from 'moment'
import cInvoicePayment from '@/components/giro/cInvoicePayment'

const numeral = require('numeral');
var axios = require('axios');

export default {
    components : {cInvoicePayment, Money},
    props: {
        paymentGiroId : Number,
        paymentGiroDate : String,
        paymentGiroAmount : Number,
        paymentGiroMarking : String,
        paymentGiroMarkingGroup: String,
        markingIdSelected : Number,
        isGroup : Boolean,
    },

    data: () => ({
        paymentDate : '',
        optionMarkings : [],
        optionGroupMarkings : [],
        receivableGroup : [],
        modalConfirmDeposit: false,
        amountReceived : '',
        discountReceived : '',
        amountResidue : '',
        depositType : '',
        depositAmount : '', // untuk menampung kelebihan bayar
        depositRemaining : 0, // untuk menampung total sisa deposit
        depositMutasiRemaining : 0,
        totalUseDepositAmount : 0,
        totalUseDepositMutasi : 0,
        loadingGetPayment : true,
        accountNumber : '',
        description : '',
        transactionDate : '',
        loadingGetMarking: false,
        invoiceDues : [],
        loadingPost : false,
        paymentAllocates : [],
        postData : [],
        payments : [],
        searchSelectSubbranch : localStorage.getItem('user.subbranchcode'),
        subbranchs: '',
        isbalanceAmount: (this.amountReceived - this.totalUseDepositMutasi) == this.paymentPendingAmount,
        optionClaims : [],
        claims : [],
        loadingGetClaims : false,
        modalConfirmAutoDeposit: false,
        tableColumns: [
            {
                title: 'Tgl',
                key: 'paymentDate',
                sortable: false
            },
            {
                title: 'Marking',
                key: 'markingHeaderId',
                sortable: false
            },
            {
                title: 'Keterangan',
                key: 'description',
                sortable: false
            },
            {
                title: 'Jumlah',
                key: 'creditAmount',
                sortable: false
            }
        ],
        filterInput : '',
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 0,
          masked: false
        },
        category: '',
        paymentGiro : Object,
        finishLoading: false
    }),
    methods: {
        isDeviation : function(invoiceDue){
            if(invoiceDue.allocateAmount + invoiceDue.useDepositAmount > invoiceDue.receivableRemaining){
                return true;
            }
            return false;
        },
        countTotalAllocateAmount: function(invoiceDue){
            return (invoiceDue.allocateAmount + invoiceDue.useDepositAmount) - invoiceDue.receivableRemaining;
        },
        setAllocateAmount : function(invoiceDue){
            if(this.isDeviation(invoiceDue)){
                invoiceDue.deviationAmount = this.countTotalAllocateAmount(invoiceDue)
            } else {
                invoiceDue.deviationAmount = 0
            }

            console.log(invoiceDue)

            var index = _.findIndex(this.invoiceDues, {id: invoiceDue.id});

            // Replace item at index using native splice
            this.invoiceDues.splice(index, 1, invoiceDue);

            // var invoiceDueChanged = _.find(this.invoiceDues, {id: invoiceDue.id});
            this.setResidueAmount(true);
        },
        countTotalAllocateMutasiAmount: function (invoiceDue) {
            return (invoiceDue.allocateMutasiAmount + invoiceDue.useDepositMutasiAmount) - invoiceDue.receivableRemaining;
        },
        setAllocateMutasiAmount: function (invoiceDue) {
            if (this.isDeviation(invoiceDue)) {
                invoiceDue.deviationAmount = this.countTotalAllocateMutasiAmount(invoiceDue)
            } else {
                invoiceDue.deviationAmount = 0
            }

            var index = _.findIndex(this.invoiceDues, { id: invoiceDue.id });

            // Replace item at index using native splice
            this.invoiceDues.splice(index, 1, invoiceDue);

            // var invoiceDueChanged = _.find(this.invoiceDues, {id: invoiceDue.id});
            this.setResidueAmount(true);

            this.totalAmountSelect = 0

            if (this.isGroup) {
                this.receivableGroup.find(o => o.markingheadercode == this.selectGroup).invoiceDue.forEach(o => {
                    this.totalAmountSelect += o.allocateAmount
                })
            }
        },
        setResidueAmount: function (fromChild) {
            let allocateAmounts = _.sumBy(this.invoiceDues, 'allocateAmount');
            let allocateDiscountAmounts = _.sumBy(this.invoiceDues, 'discountAmount');
            let allocateDepositMutasi = _.sumBy(this.invoiceDues, 'useDepositMutasi');
            this.amountResidue = this.amountReceived - (allocateAmounts + allocateDepositMutasi);

            if (fromChild) {
                this.amountReceived = allocateAmounts + allocateDepositMutasi;
                this.totalUseDepositAmount = _.sumBy(this.invoiceDues, 'useDepositAmount');
                this.totalUseDepositMutasi = _.sumBy(this.invoiceDues, 'useDepositMutasi');
                this.discountReceived = allocateDiscountAmounts;
            }

            let sumDeviation = _.sumBy(this.invoiceDues, 'deviationAmount');
            this.depositAmount = sumDeviation
        },
        getDepositRemaining: function(){
            if(this.markingIdSelected !== ''){
                return HTTP.get('deposit/remaining/' + this.markingIdSelected)
            } else {
                this.depositRemaining = 0;
            }
        },
        getDepositMutasiRemaining: function () {
            if (this.markingIdSelected !== '') {
                return HTTP.get('deposit/mutasi/' + this.markingIdSelected)
            } else {
                this.depositMutasiRemaining = 0;
            }
        },
        getInvoiceDueUnSettled: function(){
            if(this.markingIdSelected !== ''){
                return HTTP.get('invoiceDue/unsettled/' + this.markingIdSelected)
            } else {
                this.invoiceDues = []
            }
        },
        getInvoiceDueUnSettledByGroup: function(){
            if(this.markingIdSelected !== ''){
                return HTTP.get('invoiceDue/unsettledByGroup/' + this.markingIdSelected)
            } else {
                this.invoiceDues = []
            }
        },
        getSubbranch: function(){
                HTTP
                .get('subbranch')
                .then(response => {
                    this.subbranchs = response.data
                })
                .catch(e => {
                    //console.log(e);
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },

        getInvoiceData: function(){
            this.loadingGetPayment  = true;
            this.receivableGroup = []
            this.invoiceDues = []
            this.amountResidue = ''
            this.amountReceived = ''
            this.description = ''
            this.depositRemaining = 0;
            this.totalUseDepositAmount = 0;

            if(this.markingIdSelected == '' || this.isGroup){
                this.loadingGetPayment = false;
                return;
            }

            let parent = this;

            axios.all([
                this.getInvoiceDueUnSettled(),
                this.getDepositRemaining(),
                this.getDepositMutasiRemaining()
            ]).then(axios.spread((unSettledRes, depositRemainingRes, depositMutasiRes) => {
                let invoiceDuesFormatted = []

                _.forEach(unSettledRes.data, function(value) {
                    // console.log(value.id)

                    let receivableType = value.receivable.type;

                    let invoicefee = value.receivable.debitAmount;
                    let invoicedate = value.receivable.transactionDate;
                    let invoicedatedue = '';

                    if(receivableType != 'MAN'){
                        let invoicefee = value.receivable.invoice.invoicefee;
                        let invoicedatedue = value.receivable.invoice.invoicedatedue;
                        let invoicedate = value.receivable.invoice.invoicedate;
                    }

                    let paymentSum = value.paymentSum;
                    let receivableRemaining = invoicefee - paymentSum;
                    let receivableDebitAmount = value.receivable.debitAmount;

                    console.log(receivableRemaining);
                    let payment = {
                        id : value.id,
                        receivableId : value.receivableId,
                        invoicefee : invoicefee, // Jika ada invoice, nilai ini dapat berubah jika repricing
                        paymentSum : paymentSum,
                        receivableRemaining : receivableRemaining,
                        description : value.receivable.description,
                        invoicedate : invoicedate, //numeral(value.receivable.creditAmount).format('0,0')
                        invoicedatedue : invoicedatedue,
                        receivableDebitAmount : receivableDebitAmount, // menyimpan nilai awal
                        allocateAmount : 0,
                        deviationAmount : 0, // untuk menyimpan kelebihan bayar
                        useDepositAmount : 0, // nilai penggunaan deposit (jika ada deposit)
                        useDepositMutasi: 0,
                        markingHeaderId : value.receivable.markingHeaderId,
                        giroAmount : 0,
                        discountAmount : 0
                    }

                    invoiceDuesFormatted.push(payment);
                });

                if(invoiceDuesFormatted.length > 0) {
                    invoiceDuesFormatted = _.sortBy(invoiceDuesFormatted, ['invoicedate'], function(value) {return new Date(value);});

                    let giroAmount = this.paymentGiroAmount;
                    let index = 0;

                    if(giroAmount && giroAmount > 0) {
                      _.forEach(invoiceDuesFormatted, function(value) {
                        if (giroAmount && giroAmount > 0 && giroAmount > value.receivableRemaining ) {
                          invoiceDuesFormatted[index].giroAmount = value.receivableRemaining;
                          giroAmount = giroAmount - value.receivableRemaining;
                        } else if (giroAmount && giroAmount > 0 && giroAmount <= value.receivableRemaining) {
                          invoiceDuesFormatted[index].giroAmount = giroAmount;
                          giroAmount = 0;
                        }

                        index++;
                      });
                    }

                    console.log(depositRemainingRes.data.remaining);

                    parent.invoiceDues =  invoiceDuesFormatted;
                    parent.depositRemaining = depositRemainingRes.data.remaining
                    parent.depositMutasiRemaining = depositMutasiRes.data.remaining
                    console.log('parent.invoiceDues : ', parent.invoiceDues);
                } else {
                    if(this.markingIdSelected){
                        // this.$Message.info('Piutang tidak ditemukan');
                        parent.modalConfirmAutoDeposit = true
                    }
                }
                parent.loadingGetPayment = false;
                this.getClaims();
            }))
            .catch(e => {
              console.log(e)
                this.loadingGetPayment = false;
                this.$Notice.error({
                    title: "Error",
                    desc: 'Silahkan Cek Menu Piutang > Hapus Piutang',
                    duration: 0
                });
            });
        },

        getInvoiceDataByGroupMarking: function(){
            this.invoiceDues = []
            this.amountResidue = ''
            this.amountReceived = ''
            this.description = ''
            this.depositRemaining = 0;
            this.totalUseDepositAmount = 0;
            this.totalUseDepositMutasi = 0;

            if(this.markingIdSelected == '' || this.isGroup ==  false){
                this.loadingGetPayment = false;
                return;
            }

            let parent = this;

            axios.all([
                this.getInvoiceDueUnSettledByGroup(),
                this.getDepositRemaining()
            ]).then(axios.spread((unSettledRes, depositRemainingRes) => {
                let invoiceDuesFormatted = []
                this.receivableGroup = []

                _.forEach(unSettledRes.data, function(value) {
                    // console.log(value.id)

                    let receivableType = value.receivable.type;

                    let invoicefee = value.receivable.debitAmount;
                    let invoicedate = value.receivable.transactionDate;
                    let invoicedatedue = '';

                    if(receivableType != 'MAN'){
                        let invoicefee = value.receivable.invoice.invoicefee;
                        let invoicedatedue = value.receivable.invoice.invoicedatedue;
                        let invoicedate = value.receivable.invoice.invoicedate;
                    }

                    let paymentSum = value.paymentSum;
                    let receivableRemaining = invoicefee - paymentSum;
                    let receivableDebitAmount = value.receivable.debitAmount;

                    let payment = {
                        id : value.id,
                        receivableId : value.receivableId,
                        invoicefee : invoicefee, // Jika ada invoice, nilai ini dapat berubah jika repricing
                        paymentSum : paymentSum,
                        receivableRemaining : receivableRemaining,
                        description : value.receivable.description,
                        invoicedate : invoicedate, //numeral(value.receivable.creditAmount).format('0,0')
                        invoicedatedue : invoicedatedue,
                        receivableDebitAmount : receivableDebitAmount, // menyimpan nilai awal
                        allocateAmount : 0,
                        deviationAmount : 0, // untuk menyimpan kelebihan bayar
                        useDepositAmount : 0, // nilai penggunaan deposit (jika ada deposit)
                        useDepositMutasi: 0,
                        markingHeaderId : value.receivable.markingHeaderId,
                        markingHeaderCode : value.receivable.marking_minified.markingheadercode,
                    }

                    invoiceDuesFormatted.push(payment);
                });

                if(invoiceDuesFormatted.length > 0) {
                    invoiceDuesFormatted = _.sortBy(invoiceDuesFormatted, ['invoicedate'], function(value) {return new Date(value);});

                    parent.receivableGroup = groupBy(invoiceDuesFormatted, 'markingHeaderCode', 'markingheadercode', 'invoiceDue')
                    console.log(parent.receivableGroup);

                    parent.invoiceDues =  invoiceDuesFormatted;
                    console.log(invoiceDuesFormatted);
                    parent.depositRemaining = depositRemainingRes.data.remaining
                } else {
                    if(this.markingIdSelected){
                            this.$Message.info('Piutang tidak ditemukan');
                        // parent.$Notice.error({
                        //     title: '',
                        //     desc: 'Piutang tidak ditemukan',
                        //     duration: 5
                        // });
                    }
                }
                parent.loadingGetPayment = false;
            }))
            .catch(e => {
                this.loadingGetPayment = false;
                this.$Notice.error({
                    title: "Error",
                    desc: 'Silahkan Cek Menu Piutang > Hapus Piutang',
                    duration: 0
                });
            });
        },

        postPayment: function(){

            if(this.depositAmount > 0 && this.depositType==''){
                this.modalConfirmDeposit = true;
                return;
            } else {
                this.modalConfirmDeposit = false;
            }

            this.loadingPost = true
            let paymentAllocates = [];
            _.forEach(this.invoiceDues, function(invoiceDue) {
                if((invoiceDue.allocateAmount + invoiceDue.useDepositAmount != 0 || invoiceDue.allocateAmount + invoiceDue.useDepositMutasi != 0) ||
                    invoiceDue.invoicefee == 0)
                {
                    amountDeposit += invoiceDue.useDepositMutasi;

                    let paymentAllocate = {
                        invoicefee : invoiceDue.invoicefee,
                        invoiceDueId : invoiceDue.id,
                        allocateAmount : invoiceDue.allocateAmount,
                        receivableRemaining : invoiceDue.receivableRemaining,
                        useDepositAmount : invoiceDue.useDepositAmount,
                        useDepositMutasi: invoiceDue.useDepositMutasi,
                        description: invoiceDue.description
                    }
                    paymentAllocates.push(paymentAllocate);
                }
            });

            console.log(this.amountReceived)
            this.paymentAllocates = paymentAllocates;
            let transactionDate = moment(this.paymentDate).format('YYYY/MM/DD');
            let paymentGiroId = this.paymentGiroId;
            HTTP
            .post('payment/pay', {
                markingHeaderId: this.markingIdSelected,
                amount : this.amountReceived,
                transactionDate : transactionDate,
                description : this.description,
                accountNumber : this.accountNumber,
                depositAmount : this.depositAmount,
                paymentAllocates : this.paymentAllocates,
                amountDeposit: amountDeposit,
                depositType: this.depositType,
                category: this.category,
                paymentGiroId: paymentGiroId
            })
            .then(response => {
                this.loadingPost = false

                this.$Message.success({
                    content: 'Pembayaran Berhasil',
                    duration: 5
                });

                HTTP.post('transaction-note-giro/create', { paymentGiroId })
                .then(response => {
                    this.$Message.success({
                        content: 'Nota transaksi otomatis, berhasil dibuat ! ',
                        duration: 5
                    });

                    if (this.paymentGiroId) {
                        this.goToPaymentGiroList()
                    } else {
                        this.getInvoiceData();
                    }
                })
                .catch(e => {
                    isDescriptionResponse = e;

                    this.$Notice.error({
                        title: "Transaction Note Error",
                        desc: isDescriptionResponse,
                        duration: 5
                    });
                });
            })
            .catch(e => {
                this.loadingPost = false
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },
        postPaymentGiro: function(){

            if(this.depositAmount > 0 && this.depositType==''){
                this.modalConfirmDeposit = true;
                return;
            } else {
                this.modalConfirmDeposit = false;
            }

            this.loadingPost = true
            let paymentAllocates = [];
            let paymentDiscountAllocates = [];
            let amountDeposit = 0;

            console.log(this.invoiceDues);


            _.forEach(this.invoiceDues, function(invoiceDue) {
                if((invoiceDue.allocateAmount + invoiceDue.useDepositAmount != 0 ||
                    invoiceDue.allocateAmount + invoiceDue.useDepositMutasi != 0) ||
                    invoiceDue.invoicefee == 0)
                {
                    amountDeposit += invoiceDue.useDepositMutasi;

                    console.log("amountDeposit:", amountDeposit);


                    let paymentAllocate = {
                        invoicefee : invoiceDue.invoicefee,
                        invoiceDueId : invoiceDue.id,
                        allocateAmount : invoiceDue.allocateAmount,
                        receivableRemaining : invoiceDue.receivableRemaining,
                        useDepositAmount : invoiceDue.useDepositAmount,
                        useDepositMutasi: invoiceDue.useDepositMutasi,
                        description: invoiceDue.description
                    }
                    paymentAllocates.push(paymentAllocate);
                }

                if((invoiceDue.allocateAmount + invoiceDue.useDepositAmount != 0 ||
                    invoiceDue.invoicefee == 0) && (invoiceDue.discountAmount && invoiceDue.discountDescription))
                {
                    let paymentAllocate = {
                        invoicefee : invoiceDue.invoicefee,
                        invoiceDueId : invoiceDue.id,
                        allocateAmount : invoiceDue.discountAmount,
                        receivableRemaining : invoiceDue.receivableRemaining,
                        useDepositAmount : 0,
                        useDepositMutasi: 0,
                        description : invoiceDue.discountDescription,
                    }
                    paymentDiscountAllocates.push(paymentAllocate);
                }
            });

            this.paymentAllocates = paymentAllocates;
            let transactionDate = moment(this.paymentDate).format('YYYY/MM/DD');
            let paymentGiroId = this.paymentGiroId;

            HTTP
            .post('payment/pay', {
                markingHeaderId: this.markingIdSelected,
                amount : this.amountReceived,
                transactionDate : transactionDate,
                description : this.description,
                accountNumber : this.accountNumber,
                depositAmount : this.depositAmount,
                paymentAllocates : this.paymentAllocates,
                depositType: this.depositType,
                category: this.category,
                paymentGiroId: paymentGiroId,
                paymentDiscountAllocates : paymentDiscountAllocates,
                amountDeposit: amountDeposit,
                claims: this.claims,
            })
            .then(response => {
                this.loadingPost = false

                this.$Message.success({
                    content: 'Pembayaran Berhasil',
                    duration: 5
                });

                HTTP.post('transaction-note-giro/create', { paymentGiroId })
                .then(response => {
                    this.$Message.success({
                        content: 'Nota transaksi otomatis, berhasil dibuat ! ',
                        duration: 5
                    });

                    if (this.paymentGiroId) {
                        this.goToPaymentGiroList()
                    } else {
                        this.getInvoiceData();
                    }
                })
                .catch(e => {
                    isDescriptionResponse = e;

                    this.$Notice.error({
                        title: "Transaction Note Error",
                        desc: isDescriptionResponse,
                        duration: 5
                    });
                });
            })
            .catch(e => {
                this.loadingPost = false
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },
        postPaymentByGroup: function(){

            if(this.depositAmount > 0 && this.depositType==''){
                this.modalConfirmDeposit = true;
                return;
            } else {
                this.modalConfirmDeposit = false;
            }

            var subbranchcode = this.searchSelectSubbranch;
            var branchcode = this.searchSelectSubbranch;
            var paymentDate = this.paymentDate;
            var amountReceived = this.amountReceived;
            var transactionDate = this.transactionDate;
            var description = this.description;
            var accountNumber = this.accountNumber;
            var depositAmount = this.depositAmount;
            var depositType = this.depositType;
            var category = this.category;
            var paymentGiroId = this.paymentGiroId;

            var groupByCategory = _.groupBy(this.invoiceDues, invoiceDue => invoiceDue.markingHeaderId);
            this.loadingPost = true

            var isResponse = true;
            var isDescriptionResponse = '';

            let paymentPromises = [];

            _.forEach(groupByCategory, function(invoiceDue) {
              let parent = this;
              let paymentAllocates = [];
              let paymentDiscountAllocates = [];
              let amount = 0;
              var markingheaderid = '';
              _.forEach(invoiceDue, function(invoiceDue) {

                  if((invoiceDue.allocateAmount + invoiceDue.useDepositAmount != 0 ||
                      invoiceDue.allocateAmount + invoiceDue.useDepositMutasi != 0) ||
                    invoiceDue.invoicefee == 0)
                  {
                        let paymentAllocate = {
                            invoicefee : invoiceDue.invoicefee,
                            invoiceDueId : invoiceDue.id,
                            allocateAmount : invoiceDue.allocateAmount,
                            receivableRemaining : invoiceDue.receivableRemaining,
                            useDepositAmount : invoiceDue.useDepositAmount,
                            useDepositMutasi: invoiceDue.useDepositMutasi,
                            description: invoiceDue.description
                        }

                        amount = amount + invoiceDue.allocateAmount;
                        paymentAllocates.push(paymentAllocate);
                  }

                  if((invoiceDue.allocateAmount + invoiceDue.useDepositAmount != 0 ||
                    invoiceDue.invoicefee == 0) && (invoiceDue.discountAmount && invoiceDue.discountDescription))
                  {
                      let paymentAllocate = {
                          invoicefee : invoiceDue.invoicefee,
                          invoiceDueId : invoiceDue.id,
                          allocateAmount : invoiceDue.discountAmount,
                          receivableRemaining : invoiceDue.receivableRemaining,
                          useDepositAmount : 0,
                          description : invoiceDue.discountDescription,
                      }
                      paymentDiscountAllocates.push(paymentAllocate);
                  }

                  markingheaderid = invoiceDue.markingHeaderId;

              });

              if(amount > 0) {
                  let transactionDate = moment(paymentDate).format('YYYY/MM/DD')

                  paymentPromises.push(
                    HTTP
                    .post('payment/pay', {
                        markingHeaderId: markingheaderid,
                        amount : amount,
                        transactionDate : transactionDate,
                        description : description,
                        accountNumber : accountNumber,
                        depositAmount : depositAmount,
                        paymentAllocates : paymentAllocates,
                        depositType: depositType,
                        category: category,
                        paymentGiroId: paymentGiroId,
                        paymentDiscountAllocates : paymentDiscountAllocates
                    })
                    .then(response => {
                        isResponse = true;
                    })
                    .catch(e => {
                        isDescriptionResponse = e;
                    })
                  )
              }
            });

            // wait until all payment/pay requests are done
            Promise.all(paymentPromises)
            .then(() => {
                if (isResponse) {
                    this.loadingPost = false

                    this.$Message.success({
                        content: 'Pembayaran berhasil !',
                        duration: 5
                    });
                } else {
                    this.loadingPost = false

                    this.$Notice.error({
                        title: "Payment Error",
                        desc: isDescriptionResponse,
                        duration: 5
                    });
                }

                // create Transaction Note - New
                return HTTP.post('transaction-note-giro/create', { paymentGiroId });
            })
            .then(response => {
                this.$Message.success({
                    content: 'Nota transaksi otomatis, berhasil dibuat ! ',
                    duration: 5
                });


                if (paymentGiroId) {
                    this.goToPaymentGiroList()
                } else {
                    this.getInvoiceDataByGroupMarking();
                }
            })
            .catch(e => {
                isDescriptionResponse = e;

                this.$Notice.error({
                    title: "Transaction Note Error",
                    desc: isDescriptionResponse,
                    duration: 5
                });
            });
        },

        getMarkingByCode: _.debounce(
            function (query) {
                if (query && query !== '' && this.isGroup == false) {
                    this.loadingGetMarking = true;
                    HTTP
                    .post('marking/getBySnapshot', {
                        markingHeaderId: query,
                        subbranchcode: this.searchSelectSubbranch || null
                    })
                    .then(response => {
                        this.loadingGetMarking = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.markingheaderid,
                                label: item.markingheadercode
                            };
                        });

                        this.optionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    })
                    .catch(e => {
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionMarkings = [];
                }
            }, 300
        ),
        getGroupMarkingByCode:  _.debounce(
            function (query) {
                if (query !== '' && this.isGroup) {
                    this.loadingGetMarking = true;
                    HTTP
                    .post('markingGroup/getByCode', {
                        groupName: query
                    })
                    .then(response => {
                        this.loadingGetMarking = false;
                        let data = response.data;

                        const list = data.map(item => {
                            return {
                                value: item.id,
                                label: item.code
                            };
                        });

                        this.optionGroupMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                    })
                    .catch(e => {
                        this.$Notice.error({
                            title: "Error",
                            desc: e,
                            duration: 5
                        });
                    })
                } else {
                    this.optionGroupMarkings = [];
                }
            }, 300
        ),
        getPaymentGiro: function(){
            this.finishLoading = false
            let urlFindByFilter = 'giro/id/' + this.paymentGiroId;

            HTTP
            .get(urlFindByFilter)
            .then(response => {
                let value = response.data
                console.log({value});

                this.paymentGiro = {
                    id : value[0].id,
                    amount : value[0].giroNominal,
                    transactionDate : value[0].giroDate,
                    bankAccountName : value[0].bank_account.accountName
                }

                this.finishLoading = true
            })
            .catch(e => {
                this.finishLoading = true
                this.loadingSearch = false;
                this.$Notice.error({
                    title: "Error",
                    desc: e,
                    duration: 5
                });
            })
        },
        goToPaymentGiroList: function(){
            this.$router.push({ path: '/giro/list' })
        },
        getClaims: function () {
            this.loadingGetClaims = true;
            this.optionClaims = [];
            this.receivableClaim = [];
            this.claims = [];

            let claimData = [];

            let payload = {
              markingHeaderId: this.markingIdSelected,
              transactionDate: moment(this.paymentDate).format('DD/MM/YYYY'),
            }

            HTTP
                .post('claim/drafts', payload)
                .then(response => {
                    this.loadingGetClaims = false
                    console.log(response.data.data);

                    let claim = response.data.data.map(function (value) {
                        return {
                            value: value.id,
                            label: numeral(value.total_claim).format('0,0.00') + ' - ' + value.receivable.description
                        }
                    })

                    this.optionClaims = claim
                    claimData = response.data.data

                    claimData.forEach(data => {
                      this.receivableClaim.push({
                        id: data.receivable.id,
                        claimId: data.id,
                        description: data.receivable.description,
                      });
                    });

                    this.invoiceDues.forEach(invoiceDue => {
                      invoiceDue.claimStatus = null;

                      this.receivableClaim.forEach(receivable => {
                        console.log('invoiceDue', invoiceDue.receivableId, 'receivable', receivable.id);
                        if (invoiceDue.receivableId === receivable.id) {
                          invoiceDue.claimStatus = ' - (Ada Claim)';
                        }
                      });
                    });

                    // const receivableMap = new Map(
                    //   this.receivableClaim.map(item => [item.id, true])
                    // );

                    // this.invoiceDues.forEach(invoiceDue => {
                    //   if (receivableMap.has(invoiceDue.receivableId)) {
                    //     invoiceDue.claimStatus = ' (Ada Claim)';
                    //   }
                    // });



                }).catch(err => {
                    this.loadingGetClaims = false
                    this.$Notice.error({
                        title: "Error",
                        desc: err,
                        duration: 5
                    });
                })
        },
        setMarkingCode: function(){
            this.markingIdSelected = ''
        },
        postReceivableAsDeposit: function () {
            this.loadingPost = true
            let transactionDate = moment(this.paymentGiro.transactionDate, 'DD/MM/YYYY').format("YYYY-MM-DD");

            let payload = {
                markingHeaderId: this.markingIdSelected,
                transactionDate: this.paymentGiro.transactionDate,
                description: "TAMBAH DEPOSIT DARI GIRO",
                amount: this.paymentGiroAmount,
                giroId: this.paymentGiroId // untuk update payment_pending as isPayment
            }

            HTTP
                .post('receivable/deposit-giro/create', payload)
                .then(response => {
                    this.$Message.success({
                        content: 'Total giro berhasil ditambahkan sebagai deposit',
                        duration: 5
                    });

                    this.loadingPost = false
                    this.modalConfirmAutoDeposit = false
                })
                .catch(e => {
                    this.loadingPost = false
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
        },
    },
    filters: {
        currency: function (value) {
        if (!value) return ''
        return numeral(value).format('0,0')
        }
    },
    beforeMount() {
        this.paymentDate = this.paymentGiroDate // set & handle mutating a prop directly
    },
    mounted() {
        this.getInvoiceData()
        this.getInvoiceDataByGroupMarking()
    },
    watch: {
        amountReceived: function (newAmountReceived) {
        this.setResidueAmount(false)
        }
    },
    updated() {
        // let pendingAmount = Math.round(this.paymentPendingAmount)
        this.isbalanceAmount = (this.amountReceived - this.totalUseDepositMutasi) == this.paymentPendingAmount
        // this.isbalanceAmount = this.amountReceived == this.paymentPendingAmount
        // console.log(this.amountReceived + '-' + pendingAmount)
    },
    created() {
        this.getSubbranch();
        this.getPaymentGiro();
    }
}

function groupBy(dataToGroupOn, fieldNameToGroupOn, fieldNameForGroupName, fieldNameForChildren) {
    var result = _.chain(dataToGroupOn)
        .groupBy(fieldNameToGroupOn)
        .toPairs()
        .map(function (currentItem) {
            return _.zipObject([fieldNameForGroupName, fieldNameForChildren], currentItem);
        })
        .value();
    return result;
}


</script>



// WEBPACK FOOTER //
// GiroPaymentAdd.vue?446bd181